<template>
  <section class="orders">
    <div style="top: 100px;position: fixed;left:0;z-index: 999;" v-if="textCopy"> 
      <div class="text" v-copy='{callback,textCopy}'   style="padding: 10px;background-color: #0c0c0c;color: #fff;" >复制链接</div>
    </div>
    <div class="order-container">
      <van-list
      v-model="loading"
      :finished="finished"
      v-if="list.length != 0"
      >
        <li v-for='(item,index) in list' :key='index'><order-com :customerId='customerId' :radio="true" :radioArr='radioArr' @radioChange='radioChange' :model='item' :type='3'/></li>
        <div class="bottomShare">
          <div>扫码~定制你的专属周边~</div>
          <img src="/images/base/share_ewm.png" alt="">
        </div>
      </van-list>
      <div v-else>
        <img src='/images/order/noOrder.png' class='no-list'>
      </div>
    </div>
    <div :class="[isIPX?'tool-bar2':'']" class="tool-bar" v-show='list.length != 0 && !customerId || $route.query.shareId'>

      <div class="select" @click='checkAll'>
        <radio :checked='checkAllTag'/>
        <span class="all fs30">全选</span>
      </div>
      <div>
        <button class="primary sendback" @click='sendBack' :disabled='list.length == 0 || radioArr.length == 0'>打包寄回</button>
      </div>
    </div>
    <!-- <div style="width:100%;height:100%;background-color:rgba(0, 0, 0, 0.41);top: 0;position: fixed;">
      <div style="width: 320px;height: 200px;left: calc(50% - 160px);top: 200px;position: relative;background-color: #fff;"> 
        <div style="width:320px;height:50px;text-align: center;line-height: 50px;"> 
          <h2 style="font-size:20px">提示</h2>
        </div>
        <div style="width:320px;height:100px;text-align: center;line-height: 50px;font-size:16px"> 
          <span>点击确定复制到粘贴板，可直接发送给客户</span>
        </div>
        <div style="width:320px;height:50px;line-height: 50px;text-align: center;font-size:20px;border-top: 1px solid #ebedf0;" @click="niubi"> 
          <div class="text" v-copy='textCopy'>好的</div>
        </div>
      </div>
    </div> -->
    <!-- <van-popup v-model="wringFalg" :style="{ borderRadius: '16px' }"> 
        <div style="width:320px;height:200px"> 
            <div style="width:320px;height:50px;text-align: center;line-height: 50px;"> 
              <h2 style="font-size:20px">提示</h2>
            </div>
            <div style="width:320px;height:100px;text-align: center;line-height: 50px;font-size:16px"> 
              <span>点击确定复制到粘贴板，可直接发送给客户</span>
               
            </div>
            <div style="width:320px;height:50px;line-height: 50px;text-align: center;font-size:20px;border: 1px solid #ebedf0;" @click="niubi"> 
              <div class="text" v-copy='textCopy'>好的</div>
            </div>
          </div>
      </van-popup> -->
  </section>
</template>

<script>
  import orderApi from '@/axios/order'
  import loginApi from '@/axios/login'
  import wxShare from "@/assets/js/wx.share"
  import publicObj from '@/assets/js/public';
  import { setTimeout } from 'timers';
  import zhugeObj from '@/assets/js/track';
  export default {
    name: 'waitSendBackOrders',
    props: {
      ptype : {
        type : Number,
        default :  null
      }
    },
    data () {
      return {
        wringFalg:true,
        isIPX:false,
        finished : false,
        loading: true,
        textCopy:'',
        list : [],
        customerId : '544',
        customerName : '',
        radioArr : [],
        customerFrom : ''
      }
    },
    computed : {
      checkAllTag(){
        let arr = []
        this.list.forEach(element=>{
          // let tag = this.makeCheck(element);
          // if(!tag){
            arr.push(element);
          // }
        })
        return this.radioArr.length == arr.length && this.radioArr.length != 0;
      }
    },
    created () {
      console.log(this.$store.state.serviceUrl)
      this.isIPX=publicObj.isIPX()
      this.$route.query?this.customerId=this.$route.query.customerId:'';
      // if(this.customerId){
      //   this.customerName = this.$route.query.customerName;
      //   this.getOtherGoodsList();
      //   return;
      // }

      if(this.$route.resource == 'erp'){
        this.customerFrom = 'erp'

      }

      if(this.customerId){
        if(!this.$route.query.shareId){
          this.customerName = this.$route.query.customerName;
          this.getOtherGoodsList();
          return;
        }
        if(this.$route.query.shareId && this.$route.query.shareId == this.$store.state.customerId){
            this.customerName = this.$route.query.customerName;
            this.getOtherGoodsList();
            return;
        }
      }
     
      if(this.$route.query.customerFrom == 'erp'){
        zhugeObj.track({
          title : '客服分享-查看效果方案',
        })
      }
      this.getGoodsList();
    },
    mounted () {
      zhugeObj.track({
        title : '订单待寄回-曝光',
      })
    },
    methods: {
      callback(){
        let arr = [];
        this.list.forEach((res)=>{
          arr.push(res.goodsCode);
        })
        let params = {
          behaviorType : 20,
          goodsCodeList : arr.join(',')
        }
        orderApi.behavior(params).then((res)=>{
        })
      },
      niubi(){
        // if(this.textCopy ==''){
          this.wringFalg=false
        // }else{
          
        // }
        
      },
      makeCheck(model){
        if(model.goodsCuringServiceBoList){
          if(model.goodsCuringServiceBoList[0]){
            if(model.goodsCuringServiceBoList[0].curingServiceName == '无法修复'){
              return true;
            } 
          }
        }
        if(model.state == 99){
          return true;
        }
        return false;
      },
      checkAll(all){
        //全选
        let length = this.radioArr.length;
        let num = 0;
        let checklist = this.list.filter(item => {
          // let tag = this.makeCheck(item);
          // if(!tag){
            num++;
            return item;
          // }
        })
        
        if(num != length){
          this.radioArr = [];
          this.list.forEach(element=>{
            // let tag = this.makeCheck(element);
            // if(!tag){
              this.radioArr.push(element.id);
            // }
          })
        }else{
          this.radioArr = [];
        }
      },
      copaySourl(url){
        let link = encodeURIComponent(url);
        loginApi.sortUrl(link).then((res)=>{
          res = res?res:encodeURI(url)
          const N = " \n ";
          let text = `哈喽哈喽，您的宝贝已经拯好啦~ 点击链接${res}查看修复效果 ， 点击“打包寄回”确认地址哦~ 另外在确认寄回后将链接分享到朋友圈， 并写上20字以上的推荐语（秒删无效哦） 将截图发给大人，会为您送上价值198元的 包包护理套装一份和宝贝一起寄回哒~`
          this.textCopy = text
        })
      },
      radioChange(id){
        let index = this.radioArr.indexOf(id);
        if(index > -1){
          this.radioArr.splice(index,1);
        }else{
          this.radioArr.push(id);
        }
      },
      getPhotos(id){
        if(this.ptype != 4){
          return;
        }
        let _this = this;
        let title;
        if(this.list.length > 1){
          title = '【包拯好了】'+this.customerName+'快来确认你宝贝（们）的养护效果'
        }else{
          title = '【包拯好了】'+this.customerName+'快来确认你宝贝的养护效果'
        }
        let link = _this.$store.state.serviceUrl + '/order/list/4';
        
        if(this.customerId){
          link = _this.$store.state.serviceUrl + '/order/list/4?source=share&shareId=' +  this.$store.state.customerId + '&customerId=' + this.customerId + '&customerName=' + this.customerName + '&customerFrom=erp&utm_source=ckxgfa'
         
        }
        loginApi.codeConfig().then((res)=>{
          if(res.shareCopyEnabled){
            if(this.$route.query.resource == 'erp'){
              this.wringFalg=true
              // link = encodeURIComponent(link);
              this.copaySourl(link)
              
            }else{
              this.wringFalg=false
            }
          }
          orderApi.getPhotos(id).then((res)=>{
            setTimeout(()=>{
                
              let shareBody = {
                desc : '确认后立即寄回',
                title : title,
                imgUrl : JSON.parse(res[0].originPics)[0],
                link :link
              }; 
              wxShare(shareBody).then(()=>{
                let arr = []; 
                _this.list.forEach((res)=>{
                  arr.push(res.goodsCode);
                })
                let params = {
                  behaviorType : 20,
                  goodsCodeList : arr.join(',')
                }
                orderApi.behavior(params).then((res)=>{
                  
                })
              });
            },1000)
          })
        }) 
      },
      parentsAction(){
        this.list = [];
        this.getGoodsList();
      },
      sendBack(){
        let goodsCodes = [];
        this.list.forEach((element)=>{
          if(this.radioArr.indexOf(element.id) >= 0){
            goodsCodes.push(element.goodsCode)
          }
        })

        this.$emit('sendBack',this.radioArr);
      },
      getOtherGoodsList(){
        let params = {
          state : 30,
          encryptCustomerId : this.customerId
        };
        orderApi.waitDeliveryCustomer(params).then((res)=>{
          this.loading = false;
          this.finished = true;
          this.list = res;
          if(res.length != 0){
            this.getPhotos(res[0].id)
          }
        })
      },
      getGoodsList(){
        let _this = this
        let params = {
          state : 30
        };
        orderApi.waitDelivery(params).then((res)=>{
          this.loading = false;
          this.finished = true;
          this.list = res;
          this.list.forEach((item)=>{
            this.radioArr.push(item.id)
          })
          console.log(this.radioArr)
          setTimeout(()=>{
            if(res[0]){
              _this.getPhotos(res[0].id)
            }
            
          },500)
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.bottomShare{
  width: 690px;
  padding-top: 20px;
  text-align: center;
  font-size: 26px;
  img{
    width: 150px;
    height: 150px;
    display: block;
    margin: 20px auto 0;
  }
}

  .fs30{
    font-size:28px; 
  }
  .sendback{
    margin-right:20px;
  }
  .no-list{
    width:100%;
    margin-top: 300px;
  }
  .orders{
    // position: absolute;
    // height: 100%;
    // width: 100%;
    // top: 0;
    // left: 0;
    .order-container{
      // position: absolute;
      // top: 0;
      // left: 0;
      // bottom: 108px;
      width: 100%;
      display: flex;
      justify-content: center;
      // padding-bottom: 1000px;
      .van-list{
        width: 690px;
        li{
          width:690px;
          background:rgba(255,255,255,1);
          box-shadow:0px 2px 20px 0px rgba(0,0,0,0.1);
          border-radius:6px;
          margin-top: 30px;
        }
        .whiteBox{
          width: 100%;
          height: 700px;
        }
        .whiteBox2{
          width: 100%;
          height: 100px;
        }
      }
    }
    .tool-bar{
      position: fixed;
      width: 100%;
      display: flex;
      z-index: 9;
      align-items: center;
      height: 108px;
      bottom: 105px;
      left: 0;
      background:rgba(255,255,255,1);
      box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);

      // box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);
      justify-content: space-between;
      .select{
        display: flex;
        justify-content: center;
        padding: 0 30px;
      }
      .pay{
        margin-right: 30px;
        margin-left: 10px;
      }
      .all{
        margin-left: 20px;
        line-height: 35px;
      }
      .total{
        margin-right: 20px;
        line-height: 20px;
        position: relative;
        top:-4px;
      }
    }
    .tool-bar2{
      height: 123px;
      bottom: 120px;
    }
  }
</style>
